/**
 * scrollIntoViewWithOffset.js
 * ---------------------------
 * This script provides a utility function called `scrollIntoViewWithOffset` that
 * smoothly scrolls to a specified element on the page, taking into account an offset
 * for fixed headers or other elements that should not be overlapped by the target element.
 *
 * The function takes into account the height of elements with the class 'header-bottom'
 * and the WordPress admin bar (if present) to calculate the offset.
 *
 * To use this function, you can either import it as an ES6 module or access it via
 * the window object as window.scrollIntoViewWithOffset.
 */

const scrollIntoViewWithOffset = (selector) => {

	const headerBottom = document.querySelector('.header-bottom').getBoundingClientRect();
	let offset = headerBottom.top + headerBottom.height;
	if( document.querySelector('body').classList.contains('admin-bar') ){
		offset -= document.getElementById('wpadminbar').getBoundingClientRect().height;
	}
	window.scrollTo({
		behavior: 'smooth',
	top:
		document.querySelector(selector).getBoundingClientRect().top -
		document.body.getBoundingClientRect().top -
		offset,
	})


}

window.scrollIntoViewWithOffset = scrollIntoViewWithOffset;

export default scrollIntoViewWithOffset;